import { Component, OnInit } from '@angular/core';
import { MessageService, ConfirmationService, Message } from 'primeng/api';
import { Solicitud } from '../share/model/Solicitud';
import { SitioOcurrencia } from '../share/model/SitioOcurrencia';
import { CargueFile } from '../share/model/CargueFile';
import { MedioIngreso } from '../share/model/MedioIngreso';
import { TipoUsuario } from '../share/model/TipoUsuario';
import { Regional } from '../share/model/Regional';
import { Dependencia } from '../share/model/Dependencia';
import { Clasificacion1 } from '../share/model/Clasifiacion1';
import { SolicitudService } from '../share/service/solicitud.service';
import { TipoRequerimiento } from '../share/model/TipoRequerimiento';
import { TipoDocumento } from '../share/model/TipoDocumento';
import { Departamento } from '../share/model/Departamento';
import { CanalRespuesta } from '../share/model/CanalRespuesta';
import { CaptchaRequest } from '../share/model/CaptchaRequest';
import { IfStmt, isNgTemplate } from '@angular/compiler';
import { AnyWrapper } from '../share/model/AnyWrapper';
import { Causal } from '../share/model/Causal';
import { SourceListMap } from 'source-list-map';
import { stringify } from 'querystring';
import { ConsultaTicket } from '../share/model/ConsultaTicket';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HttpClient } from '@angular/common/http';
import swal from 'sweetalert2';
import { Response } from '../share/model/Response';


@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnInit {
  
  
  spin : boolean = false;
  nombre : string = "";
  numIdentificacion : string = "";
  email : string = "";
  edad : string = "";
  numeroCel : string = "";
  numeroFijo : string = "";
  ciudad : string = "";
  checkOne : Boolean = false;
  checkTwo : Boolean = false;
  checkThree : Boolean = false;
  ipAddress = '';
  solicitud : Solicitud;
  indicativo1 : Boolean = false;
  indicativo2 : Boolean = false;
  indicativo3 : Boolean = false;
  mensaje : Response;

  constructor(
    private http:HttpClient,
    private solicitudService:SolicitudService
  ) {}

  ngOnInit() {
    this.getIPAddress();
    this.indicativo1 = true;
    this.indicativo2 = true;
    this.indicativo3 = true;
    this.mensaje = new Response();
  }

  enviarInfo(){
   this.solicitud = new Solicitud;
   this.solicitud.nombre = this.nombre;
   this.solicitud.identificacion = this.numIdentificacion;   
   this.solicitud.edad = this.edad;
   this.solicitud.email = this.email;
   this.solicitud.numCelular = this.numeroCel;
   this.solicitud.numFijo = this.numeroFijo;
   this.solicitud.ciudad = this.ciudad;
   this.solicitud.pregunta1 = this.checkOne;
   this.solicitud.pregunta2 = this.checkTwo;
   this.solicitud.pregunta3 = this.checkThree;
   this.solicitud.ipOrigen = this.ipAddress;

   this.solicitudService.registrar(this.solicitud).subscribe(
    success => {
      this.mensaje = success;
      swal({
        title: 'Registro de solicitud',
        html: this.mensaje.mensaje,
        type: 'success',
        confirmButtonText: "OK",
        confirmButtonClass: 'btn btn-confirm-modal',
      }).then((result) => {
        location.reload();
      })
    },  
    err => {
      this.mensaje = err;
      swal("Reporte Novedad", this.mensaje.mensaje, "error")
    }
  );
   

   /*this.serviciosInconformes = new Array<SelectItem>(); 
   this.dependencias = new Array<Dependencia>();
   this.servicioInconformes = new Array<any>();
   this.regionalService.getDependencia(this.regionalId).subscribe(
     (success)=>{
      this.dependencias = success;
     },(err)=>{
       console.log(err);
     }
   )*/
 }

 getIPAddress()
  {
    this.http.get("http://api.ipify.org/?format=json").subscribe((res:any)=>{
      this.ipAddress = res.ip;
    });
  }

  efectoPreguntas(id : number){
      if(id == 1 && this.checkOne){
        this.indicativo2 = false;
        this.indicativo3 = false;
      }else if(id == 1 && !this.checkOne){
        this.indicativo2 = true;
        this.indicativo3 = true;
      }else if(id == 2 && this.checkTwo){
        this.indicativo1 = false;
        this.indicativo3 = false;
      }else if(id == 2 && !this.checkTwo){
        this.indicativo1 = true;
        this.indicativo3 = true;
      }else if(id == 3 && this.checkThree){
        this.indicativo1 = false;
        this.indicativo2 = false;
      }else if(id == 3 && !this.checkThree){
        this.indicativo1 = true;
        this.indicativo2 = true;
      }
  }
}
